import { FC, useCallback, useState } from "react";
import { Button } from "@design-system/Button/Button";
import { Radio, RadioGroup } from "@design-system/Radio/Radio";
import drawerStyles from "../AddClientDrawerStepsContainer.module.scss";
import styles from "./AddClientDrawerSteps.module.scss";

type AddAnotherEntityValue = "yes" | "no" | "";

interface Props {
    onContinue: () => void;
    onAddAnotherEntity: () => void;
    canAddAnotherEntity: boolean;
}

export const AddAnotherEntityStep: FC<Props> = ({
    onContinue,
    onAddAnotherEntity,
    canAddAnotherEntity,
}) => {
    const [shouldAddAnotherEntity, setShouldAddAnotherEntity] =
        useState<boolean>();

    const handleNext = useCallback(() => {
        if (shouldAddAnotherEntity) {
            onAddAnotherEntity();
        } else {
            onContinue();
        }
    }, [shouldAddAnotherEntity, onAddAnotherEntity, onContinue]);

    let selectedValue: AddAnotherEntityValue = "";
    if (shouldAddAnotherEntity !== undefined) {
        selectedValue = shouldAddAnotherEntity ? "yes" : "no";
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>Entity added</div>
            <div className={styles.subheader}>
                Does this client have another entity?
            </div>
            <div className={styles.subheader}>
                Multi-entity clients keep separate books per entity but roll up
                into a single workspace.
            </div>
            <RadioGroup<AddAnotherEntityValue>
                name="addAnotherEntity"
                aria-label="Add another entity"
                value={selectedValue}
                onValueChange={(value) => {
                    if (value !== "") {
                        setShouldAddAnotherEntity(value === "yes");
                    }
                }}
                className={styles.multiEntityRadioGroup}
            >
                <Radio
                    className={styles.radio}
                    label={
                        <div className={styles.main}>
                            No, all entities are added
                        </div>
                    }
                    value="no"
                />
                <Radio
                    className={styles.radio}
                    label={
                        <div className={styles.main}>
                            Yes, add another entity
                        </div>
                    }
                    value="yes"
                    disabled={!canAddAnotherEntity}
                />
            </RadioGroup>

            <div className={drawerStyles.footer}>
                <div />
                {shouldAddAnotherEntity !== undefined && (
                    <Button
                        variant="primary"
                        type="button"
                        size="xl"
                        onClick={handleNext}
                    >
                        Next
                    </Button>
                )}
            </div>
        </div>
    );
};
